export const flags = {
  CONTENT_NOT_FINISHED: true,
};
